<template>
  <v-btn-form :mode = "edit" :title="title" @close="cancel()">
    <v-form v-model="valid" ref="form">
    <v-flex v-if="!isEdit">
        <v-card-title>
          <span class="headline">{{fileItem.docName}}</span>
        </v-card-title>
        <v-card-text>
          <v-flex>
          Размещение: {{getDispalayPath(fileItem.path)}}
          </v-flex>
          <v-flex>
          Примечания: {{fileItem.desc}}
          </v-flex>
        </v-card-text>
    </v-flex>
      <v-flex v-if="isEdit">
        <v-card-title>
          <span class="headline">{{fileItem.docName}}</span>
        </v-card-title>
        <v-card-text>
        <v-layout column>
        <v-flex>
          <v-text-field
            label="Название"
            hint="Название папки"
            v-model="fileItem.docName"
            clearable
          ></v-text-field>
        </v-flex>
        <v-flex>
          <v-select
            label="Размещение в папке"
            v-model="fileItem.path"
            hint="Структура папок видна только для пользователей депонента"
            :items="getDispalayPaths()"
            item-value="key"
            item-text="value"
            v-show=false
          >
          </v-select>
        </v-flex>
        <v-flex>
          <v-textarea
            label="Примечания"
            rows="3"
            hint="Примечания видны только для пользователей депонента"
            v-model="fileItem.desc"
            clearable
          ></v-textarea>
        </v-flex>
      </v-layout>
      </v-card-text>
    </v-flex>

    </v-form>
    <template #actions>
      <v-btn v-if="!isEdit" @click="edit = !edit">Изменить</v-btn>

      <v-btn v-if="isEdit" v-show="!isNew" @click="save">Сохранить</v-btn>
      <v-btn v-if="isEdit" v-show="!isNew" @click="remove">Удалить</v-btn>
      <v-btn v-if="isEdit" v-show="isNew" @click="upload">Создать</v-btn>
      <v-spacer></v-spacer>
    </template>
</v-btn-form>
</template>

<script type="text/javascript">
  import { mapGetters } from 'vuex'
  import formats from '../../api/formats'
  import dialogs from '../common/dialogs'
  import vBtnForm from '../common/BtnForm'

  export default {
    name: 'doc-folder',
    components: {vBtnForm},
    data: () => ({
      edit: false,
      valid: false,
      imageFile: '',
      fileItem: {
        uid: null,
        fileNo: null,
        fileName: null,
        fileExt: null,
        fileSize: null,
        docName: null,
        desc: null,
        ownerInn: null,
        ownerNameShort: null,
        account: null,
        uploaded: null,
        path: null,
        tags: null,
        folder: null
      }
    }),
    props: {
      fileItemId: {
        type: String,
        default: null
      },
      newPath: {
        type: String,
        default: '/'
      }
    },
    created () {
      if (this.fileItemId) {
        var fi = this.getDepoFolderById(this.fileItemId)
        this.fileItem = fi ? Object.assign({}, fi) : Object.assign({}, this.getFileItemNew())
      } else {
        this.fileItem = this.getFileItemNew()
      }
    },
    watch: {
      fileItemId: function (newVal, oldVal) { // watch it
        var fi = this.getDepoFolderById(newVal)
        this.fileItem = fi ? Object.assign({}, fi) : Object.assign({}, this.getFileItemNew())
      }
    },
    computed: {
      ...mapGetters({
        getDepoFolderById: 'getDepoFolderById',
        getDepoDisplayPaths: 'getDepoDisplayPaths'
      }),
      isEdit () {
        return this.edit || this.isNew
      },
      isNew () {
        return this.fileItemId === null
      },
      title () {
        return this.isNew ? 'Создать папку депозитария' : this.isEdit ? 'Изменить атрибуты папки' : 'Информация о папке депозитария'
      }
    },
    methods: {
      upload () {
        this.fileItem.folder = true
        this.fileItem.path = this.newPath
        this.$store.dispatch('createDepoFolder', this.fileItem)
        this.edit = false
        this.cancel()
      },
      save () {
        this.$store.dispatch('updateDepoFolder', this.fileItem)
        this.edit = false
      },
      remove () {
        dialogs.confirm(this, 'Подтвердите', 'Удалить папку?',
          (self) => {
            self.$store.dispatch('deleteDepoFolder', self.fileItem)
            self.edit = false
            self.cancel()
          })
      },
      cancel () {
        this.edit = false
        this.fileItem = Object.assign({}, this.getFileItemNew())
        this.$emit('close')
      },
      open () {
        let url = this.getUrl(this.fileItem.uid)
        this.$store.dispatch('openLocation', url)
      },
      getFileItemNew () {
        return {
          uid: null,
          fileNo: null,
          fileName: null,
          fileExt: null,
          fileSize: null,
          docName: null,
          desc: null,
          ownerInn: null,
          ownerNameShort: null,
          account: null,
          uploaded: null,
          path: '//root',
          tags: null,
          folder: null
        }
      },
      getDispalayPath (path) {
        return this.getDepoDisplayPaths ? this.getDepoDisplayPaths.get(path) : ''
      },
      getDispalayPaths () {
        var map = this.getDepoDisplayPaths
        var result = []
        if (!map) {
          return result
        }
        map.forEach((val, key) => result.push({key: key, value: val}))
        // console.log('getDispalayPaths', result)
        return result.sort((a, b) => formats.compareString(a.value, b.value))
      }
    }

  }

</script>




// WEBPACK FOOTER //
// DocFolder.vue?254d6055